{
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "{amount} dagar gratis",
    "{amount} off": "avslag",
    "{amount} off for first {number} months.": "{amount} dei første {number} månadane.",
    "{amount} off for first {period}.": "{amount} avslag den første {period}.",
    "{amount} off forever.": "{amount} avslag for alltid.",
    "{discount}% discount": "% rabatt",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} vil ikkje lenger motta {newsletterName} nyheitsbrev.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} vil ikkje lenger motta e-post når nokon svarar på kommentarar.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} vil ikkje lenger motta dette nyheitsbrevet.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dagar gratis",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Brukar",
    "Account details updated successfully": "",
    "Account settings": "Brukarinnstillingar",
    "Add a personal note": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Når den gratis prøveperioden er over vil du bli belasta den normale prisen for abonnementet du har vald. Du kan alltids avslutta abonnementet au.",
    "Already a member?": "Allereie medlem?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Ein uventa feil har skjedd. Ver gild å prøv igjen eller <a>ta kontakt</a> viss feilen fortset.",
    "Back": "Tilbake",
    "Back to Log in": "Tilbake til innlogginga",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "",
    "Bluesky": "",
    "Cancel anytime.": "Kanseller kor tid som helst.",
    "Cancel subscription": "Avslutt abonnement",
    "Canceled": "",
    "Cancellation reason": "Grunn for avslutting",
    "Change": "Endra",
    "Change plan": "",
    "Check spam & promotions folders": "Sjekk søppelpostmappa di",
    "Check with your mail provider": "Sjekk med e-postleverandøren din",
    "Check your inbox to verify email update": "",
    "Choose": "Vel",
    "Choose a different plan": "Vel eit anna abonnement",
    "Choose a plan": "",
    "Choose your newsletters": "Vel nyheitsbrevet ditt",
    "Click here to retry": "Klikk her for å prøva på ny",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Lukk",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Kommentarar",
    "Complimentary": "Gåve",
    "Confirm": "Bekreft",
    "Confirm cancellation": "Bekreft avslutting",
    "Confirm subscription": "Bekreft abonnement",
    "Contact support": "Få hjelp",
    "Continue": "Fortset",
    "Continue subscription": "Fortset abonnement",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Kunne ikkje logga inn. Innlogginslenka er utgått.",
    "Could not update email! Invalid link.": "Kunne ikkje oppdatera e-post! Ugyldig lenke.",
    "Create a new contact": "Lag ein ny kontakt",
    "Current plan": "Noverande abonnement",
    "Delete account": "Slett brukar",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Var det ikkje meininga å gjera dette? Du kan endra preferansane dine <button>her</button>.",
    "Don't have an account?": "Har du ikkje ein brukar?",
    "Edit": "Endra",
    "Email": "E-post",
    "Email confirmation link expired.": "",
    "Email newsletter": "E-post nyheitsbrev",
    "Email newsletter settings updated": "",
    "Email preferences": "E-post preferansar.",
    "Email preferences updated.": "",
    "Emails": "E-postar.",
    "Emails disabled": "E-postar skrudd av",
    "Ends {offerEndDate}": "Sluttar {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Feil",
    "Expires {expiryDate}": "Går ut {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "Forever": "For evig",
    "Free Trial – Ends {trialEnd}": "Gratis prøveperiode – sluttar {trialEnd}",
    "Get help": "Få hjelp",
    "Get in touch for help": "Ta kontakt for å få hjelp",
    "Get notified when someone replies to your comment": "Få varsler når nokon svarar på kommenten din",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Gje tilbakemeldinger på denne artikkelen",
    "Help! I'm not receiving emails": "Hjelp! Eg får ikkje e-postar",
    "Here are a few other sites you may enjoy.": "",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Viss eit nyheitsbrev er markert som søppelpost vil dei automatisk bli avslutta for den adressa, slik at du ikkje får uønska e-postar.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Viss søppelpost-klagen var med eit uhell, eller du ønsker å byrja å få e-postar frå oss igjen, kan du abonnera på nyheitsbrev igjen ved å klikka knappen på førre skjerm.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Vis du avslutter abonnementet no, vil du framleis ha tilgang fram til {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Viss du har har e-post hos ein bedrift kan du spørra IT-avdelinga om dei kan tillata e-postar frå {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Ei innlogginslenke har blitt sendt til innboksen din. Sjekk søppelposten din om lenka ikkje kjem innan 3 minutt.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Viss du vil få e-postar igjen, er det enklaste å sjekka e-postadressa du har gitt oss for feil, og så abonnera igjen ved å klikka resubscribe på førre skjerm.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Viss du ikkje mottar nyheitsbrevet du har abonnert på, kan du prøva dette. ",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Viss du har fullført desse stega og framleis ikkje får nyheitsbrev, kan du ta kontakt med oss på {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "I tilfelle ein permanent feil mottas ved forøsk på å senda eit nyheitsbrev vil e-poster bli deaktivert på kontoen.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Legg til {senderEmail} til e-posten din si kontaktliste. Dette signaliserer til leverandøren din at e-poster frå denne adressa er til å stola på.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Mindre som dette",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Pass på at e-postane ikkje ender opp i spam-mappa. Viss dei gjer, marker dei anten som \"Dette er ikkje spam\" og/eller \"Flytt til innboks\".",
    "Manage": "Innstillinger",
    "Maybe later": "",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "",
    "month": "",
    "Monthly": "Månadleg",
    "More like this": "Meir som dette",
    "More options": "",
    "Name": "Namn",
    "Need more help? Contact support": "Treng du meir hjelp? Ta kontakt med brukarstøtte",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Nyheitsbrev kan bli skrudd av for brukaren din av to grunner: Ein tidlegare e-post har blitt markert som spam. Eller så har eit forsøk på å senda ein e-post resultert i ein permanent feil.",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Får du ikkje e-postar?",
    "Now check your email!": "Sjekk e-posten din!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Sjekk spam-mappa di om du framleis ikkje ser e-postane etter å ha abonnert på ny. Nokon e-postleverandørar kan flagga e-postar som spam basert på tidlegare e-postar. Viss dette skjer, marker den siste du mottok i spam-mappa som 'ikkje spam' og flytt tilbake til innboksen din.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "Permanent feil",
    "Phone number": "",
    "Plan": "Abonnement",
    "Plan checkout was cancelled.": "Betaling kansellert.",
    "Plan upgrade was cancelled.": "Oppgradering kansellert.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Ver gilde og fyll inn dei obligatoriske felta",
    "Podcasts": "",
    "Re-enable emails": "Aktiver e-postar på ny",
    "Recommendations": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Forynast til {price}.",
    "Resume subscription": "",
    "Retry": "Prøv på ny",
    "Save": "Lagra",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Sender innloggingslenke...",
    "Sending...": "Sender...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "",
    "Sign in": "Logg inn",
    "Sign out": "Logg ut",
    "Sign up": "Registrer deg",
    "Signup error: Invalid link": "Registreringsfeil: Ugyldig lenke",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Beklagar, det verka ikkje.",
    "Spam complaints": "Spamklagar",
    "Start {amount}-day free trial": "Start {amount}-dagar gratis prøveperiode",
    "Starting {startDate}": "Starter {startDate}",
    "Starting today": "Starter idag",
    "Submit feedback": "Gje oss tilbakemeldinger",
    "Subscribe": "Abonner",
    "Subscribed": "Abonnert",
    "Subscription plan updated successfully": "",
    "Success": "Vellykka",
    "Success! Check your email for magic link to sign-in.": "Vellykka! Sjekk e-posten din for ei innlogginslenke.",
    "Success! Your account is fully activated, you now have access to all content.": "Vellykka! Brukaren din er aktivert, du har no tilgang til alt innhald.",
    "Success! Your email is updated.": "Vellykka! E-posten din er oppdatert.",
    "Successfully unsubscribed": "Vellykka kansellering.",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Takk for tilbakemeldingen!",
    "That didn't go to plan": "Det gjekk ikkje etter planen",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "E-postadressa me har på deg er {memberEmail} – viss det ikkje er riktig, kan du oppdatera i <button>brukarinnstillingane</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Det var eit problem med å senda tilbakemeldinga di. Vennligst prøv igjen litt seinare.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "Denne sida er kun for inviterte, ta kontakt med eigaren for tilgang.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Klikk på bekreftelseslenka i innboksen din for å fullføra registreringa. Sjekk spam-mappa di om lenka ikkje har kome innan 3 minutt.",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Prøv gratis i {amount} dagar, deretter {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Få tilgang til alle nyheitsbreva med å bli ein betalande abonnent.",
    "Unsubscribe from all emails": "Slutt å motta e-postar",
    "Unsubscribed": "Abonnement avslutta",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Å avslutta e-postabonnementa vil ikkje kansellera det betalta abonnementet ditt til {title}",
    "Update": "Oppdater",
    "Update your preferences": "Oppdater preferansane dine",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "",
    "Verify your email address is correct": "Bekreft at e-posten din er riktig",
    "Verifying...": "",
    "View plans": "Sjå abonnementa",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Me kunne ikkje avslutta abonnementet ditt då me ikkje fann e-postadressa di. Vennligst ta kontakt med eigaren av sida.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "Velkommen tilbake, {name}!",
    "Welcome back!": "Velkommen tilbake!",
    "Welcome to {siteTitle}": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Når ein innboks ikkje klarar å akseptera ein e-post blir det kalla ein bounce. I nokre tilfelle blir ein bounce registrert som ein permanent feil når ein e-postadresse er ugyldig eller ikkje eksisterer.",
    "Why has my email been disabled?": "Kvifor har e-posten min blitt deaktivert?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Årleg",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "For augneblikket har du eit gratis medlemsskap. Oppgrader til eit betalande for å få full tilgang.",
    "You have been successfully resubscribed": "No abonnerer du igjen",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "For augneblikket mottek du ingen e-postar",
    "You're not receiving emails": "Du mottek ikkje e-postar",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Du mottar ikkje e-postar. Anten fordi du har markert dei som spame, eller fordi dei ikkje kan bli levert til e-posten du har gitt oss.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Vellykka innlogging.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "",
    "Your account": "Din brukar",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Dine tilbakemeldinger hjelper oss å forma tilbodet vårt.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Ditt abonnement går ut den {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Ditt abonnement vil fornyast den {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Ditt abonnement vil byrja den {subscriptionStart}"
}
